var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.modalShown,
          expression: "modalShown"
        }
      ],
      staticClass: "modal",
      attrs: { id: "modal" }
    },
    [
      _c("div", { class: { "modal-main": true, layoutType: _vm.layoutType } }, [
        _vm.title
          ? _c("div", { class: "title-area " + _vm.titleAreaAddStyle }, [
              _c("h2", [_vm._v(_vm._s(_vm.title))])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { class: "message-area " + _vm.messageAreaAddStyle },
          _vm._l(_vm.messages, function(m, index) {
            return _c(
              "div",
              {
                key: index,
                domProps: {
                  innerHTML: _vm._s(m != null ? m.replace(/\n/g, "<br/>") : "")
                }
              },
              [_vm._v("\n        " + _vm._s(m) + "\n      ")]
            )
          })
        ),
        _vm._v(" "),
        _c("div", { staticClass: "button-area" }, [
          _c(
            "button",
            {
              staticClass: "main_btn",
              attrs: { type: "button" },
              on: { click: _vm.onOkLoc }
            },
            [_vm._v(_vm._s(_vm.okBtnLabel))]
          ),
          _vm._v(" "),
          _vm.modalType !== "message"
            ? _c(
                "button",
                {
                  staticClass: "main_btn",
                  attrs: { type: "button" },
                  on: { click: _vm.onCancelLoc }
                },
                [_vm._v(_vm._s(_vm.cancelBtnLabel))]
              )
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-206b4d6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-206b4d6e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/components/common/Modal.vue
// module id = null
// module chunks = 